

export interface ZIndexConfig {
  category: string;
  zIndex: number;
  description: string;
}

export const Z_INDEX_CONFIG: ZIndexConfig[] = [
  
  { category: 'base', zIndex: 0, description: 'Base do avatar' },
  { category: 'skin', zIndex: 0, description: 'Tom de pele (substitui base)' },
  
  
  { category: 'shoes', zIndex: 1, description: 'Sapatos' },
  { category: 'pants', zIndex: 2, description: 'Calças' },
  { category: 'lower_body', zIndex: 2, description: 'Parte inferior do corpo' },
  { category: 'shirt', zIndex: 3, description: 'Camisas/Blusas' },
  { category: 'upper_body', zIndex: 3, description: 'Parte superior do corpo' },
  
  
  { category: 'face', zIndex: 4, description: 'Rosto/Expressões' },
  { category: 'expressions', zIndex: 4, description: 'Expressões faciais' },
  
  
  { category: 'hair', zIndex: 5, description: 'Cabelo' },
  { category: 'facial_hair', zIndex: 6, description: 'Bigode/Barba' },
  
  
  { category: 'glasses', zIndex: 7, description: 'Óculos' },
  { category: 'head_props', zIndex: 7, description: 'Acessórios faciais' },
  
  
  { category: 'hand_props', zIndex: 9, description: 'Acessórios de mão' },
  { category: 'gloves', zIndex: 8, description: 'Luvas' },
  
  
  { category: 'body_props', zIndex: 8, description: 'Acessórios do corpo' },
  { category: 'bag', zIndex: 9, description: 'Bolsas/Mochilas' },
  { category: 'accessories', zIndex: 9, description: 'Acessórios gerais' },
  
  
  { category: 'head_props', zIndex: 10, description: 'Acessórios de cabeça' },
  { category: 'hat', zIndex: 10, description: 'Chapéus/Bonés' },
  
  
  { category: 'pets', zIndex: 11, description: 'Pets/Companheiros' },
  { category: 'companions', zIndex: 11, description: 'Companheiros' },
  
  
  { category: 'decoration', zIndex: 12, description: 'Decorações' },
  
  
  { category: 'background', zIndex: -1, description: 'Fundo (atrás de tudo)' },
  { category: 'special', zIndex: 13, description: 'Itens especiais' },
];

const Z_INDEX_MAP = new Map<string, number>();
Z_INDEX_CONFIG.forEach(config => {
  Z_INDEX_MAP.set(config.category, config.zIndex);
});

export function getZIndexForCategory(category: string): number {
  const zIndex = Z_INDEX_MAP.get(category);
  
  if (zIndex !== undefined) {
    return zIndex;
  }
  
  
  const fallbacks = [
    { pattern: /hair|cabelo/i, zIndex: 5 },
    { pattern: /face|rosto|expression/i, zIndex: 4 },
    { pattern: /shirt|camisa|top|blusa/i, zIndex: 3 },
    { pattern: /pants|calça|bottom/i, zIndex: 2 },
    { pattern: /shoe|sapato|feet/i, zIndex: 1 },
    { pattern: /glass|oculos/i, zIndex: 7 },
    { pattern: /hat|chapeu|bone/i, zIndex: 10 },
    { pattern: /bag|bolsa|mochila/i, zIndex: 9 },
    { pattern: /pet|animal/i, zIndex: 11 },
    { pattern: /effect|efeito/i, zIndex: 12 },
  ];
  
  for (const fallback of fallbacks) {
    if (fallback.pattern.test(category)) {
            return fallback.zIndex;
    }
  }
  
  
    return 5;
}

export function applyAutoZIndex<T extends { category: string; zIndex?: number }>(item: T): T {
  const autoZIndex = getZIndexForCategory(item.category);
  
  return {
    ...item,
    zIndex: autoZIndex
  };
}

export function organizeItemsByZIndex<T extends { category: string; zIndex?: number }>(items: T[]): T[] {
  return items
    .map(applyAutoZIndex)
    .sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
}

export function getCategoriesByZIndex(): ZIndexConfig[] {
  return [...Z_INDEX_CONFIG].sort((a, b) => a.zIndex - b.zIndex);
}

export function validateItemZIndex<T extends { category: string; zIndex?: number }>(item: T): boolean {
  const expectedZIndex = getZIndexForCategory(item.category);
  return item.zIndex === expectedZIndex;
}

export function fixItemsZIndex<T extends { category: string; zIndex?: number }>(items: T[]): T[] {
  return items.map(item => {
    const correctZIndex = getZIndexForCategory(item.category);
    if (item.zIndex !== correctZIndex) {
            return { ...item, zIndex: correctZIndex };
    }
    return item;
  });
}

export function debugZIndexConfig(): void {
    getCategoriesByZIndex().forEach(config => {
      });
  }

export function debugItemsZIndex<T extends { category: string; zIndex?: number; id?: string }>(items: T[]): void {
    const sortedItems = [...items].sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
  
  sortedItems.forEach(item => {
    const expectedZIndex = getZIndexForCategory(item.category);
    const isCorrect = item.zIndex === expectedZIndex;
    const status = isCorrect ? '✅' : '❌';
    
      });
  }
